import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileForgotPasswordComponent } from './mobile-forgot-password.component';
import { MaterialMdcModule } from '../shared/material-mdc.module';
import { SharedModule } from '../shared/shared.module';
import { MobileForgotPasswordRoutingModule } from './mobile-forgot-password-routing.module';
import { ValidatePasswordModule } from '../shared/componets/validate-password/validate-password.module';

@NgModule({
  declarations: [
    MobileForgotPasswordComponent
  ],
  exports: [
    MobileForgotPasswordComponent
  ],
  imports: [
    CommonModule,
    MaterialMdcModule,
    SharedModule,
    MobileForgotPasswordRoutingModule,
    ValidatePasswordModule
  ]
})
export class MobileForgotPasswordModule { }
